export const Marquee = ({ items = [], className = "" }) => {
  const content = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden whitespace-nowrap border-y border-tira-accent/15 bg-tira-bgAlt py-5 ${className}`}
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        {content.map((item, i) => (
          <span
            key={i}
            className="font-heading italic text-2xl sm:text-3xl mx-6 flex items-center gap-6 text-tira-text"
          >
            {item}
            <span className="text-tira-jade not-italic text-base">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
